// extracted by mini-css-extract-plugin
export default {"richText":"DiaryRichTextCell_richText__HU1H1"};